module.exports = __webpack_public_path__ + "img/demo02.f8808e4f.png";